/* Veluora – skrypt motywu: koszyk (AJAX), galeria, animacje */
(function(){
  'use strict';
  var V = window.V || {};
  var R = V.routes || {};
  var root = document.documentElement;
  var reduced = root.classList.contains('reduced');
  function $(s, r){ return (r || document).querySelector(s); }
  function $$(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function path(base, suffix){ return (base || '/').replace(/\/$/, '') + suffix; }

  /* ---------- kwoty ---------- */
  function money(cents){
    var fmt = V.moneyFormat || '{{amount_with_comma_separator}} zł';
    var n = Number(cents) || 0;
    function delim(prec, th, dec){
      var parts = (n / 100).toFixed(prec).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (parts[1] ? dec + parts[1] : '');
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var v;
    switch (m ? m[1] : 'amount'){
      case 'amount_no_decimals': v = delim(0, ',', '.'); break;
      case 'amount_with_comma_separator': v = delim(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = delim(0, '.', ','); break;
      case 'amount_with_space_separator': v = delim(2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = delim(0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': v = delim(2, "'", '.'); break;
      default: v = delim(2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]*>/g, '');
  }

  /* ---------- komunikat ---------- */
  var toastEl = $('[data-toast]'), toastTimer;
  function toast(text, isErr){
    if (!toastEl) return;
    toastEl.textContent = text;
    toastEl.classList.toggle('err', !!isErr);
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ toastEl.classList.remove('show'); }, isErr ? 3800 : 2200);
  }

  /* ---------- zapytania do koszyka ---------- */
  function req(url, body){
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
      credentials: 'same-origin'
    }).then(function(r){
      return r.json().catch(function(){ return {}; }).then(function(j){
        if (!r.ok){ var e = new Error(j.description || j.message || 'Coś poszło nie tak. Spróbuj ponownie.'); e.status = r.status; throw e; }
        return j;
      });
    });
  }
  function getCart(){ return req(path(R.cart, '.js')); }

  /* ---------- szuflada koszyka ---------- */
  var drawer = $('[data-cart-drawer]'), overlay = $('[data-cart-overlay]');
  var body = $('[data-cart-body]'), foot = $('[data-cart-foot]');
  var lastFocus = null, noteCleared = false;

  function isOpen(){ return drawer && drawer.classList.contains('show'); }
  function openDrawer(){
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('show'); overlay.classList.add('show');
    if (bar) bar.classList.remove('show');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function(){ drawer.focus({ preventScroll: true }); }, 50);
  }
  function closeDrawer(){
    if (!drawer) return;
    drawer.classList.remove('show'); overlay.classList.remove('show');
    if (bar && lastCart) setBar(lastCart); else if (bar && bar.querySelector('b') && parseInt(bar.querySelector('b').textContent, 10) > 0) bar.classList.add('show');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  var bar = $('[data-cart-bar]'), barTxt = $('[data-cart-bar-txt]');
  function setBar(cart){
    if (!bar || !cart) return;
    barTxt.innerHTML = '<b>' + cart.item_count + ' szt.</b> · ' + money(cart.total_price);
    bar.classList.toggle('show', cart.item_count > 0 && !isOpen());
  }

  function setCount(n, bump){
    $$('[data-cart-count]').forEach(function(el){
      el.textContent = n;
      el.classList.toggle('is-empty', !n);
      if (bump && n){ el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
    });
    $$('[data-cart-label-template]').forEach(function(el){
      el.setAttribute('aria-label', el.getAttribute('data-cart-label-template').replace('[count]', n));
    });
  }

  function imgUrl(src, w){
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  var lastCart = null;
  function render(cart){
    if (!drawer) return;
    clearOldNote(cart);
    lastCart = cart;
    setCount(cart.item_count);
    setBar(cart);
    if (!cart.item_count){
      body.innerHTML = '<div class="vc-empty">Koszyk jest pusty.<br>Wybierz torebkę z katalogu.<br><a class="btn btn-gold" href="' + esc(path(R.root, '/collections/all')) + '">Przejdź do katalogu</a></div>';
      foot.innerHTML = '';
      return;
    }
    var h = '', original = 0;
    cart.items.forEach(function(it){
      original += it.original_line_price;
      var variant = (!it.product_has_only_default_variant && it.variant_title) ? '<div class="u">' + esc(it.variant_title) + '</div>' : '';
      var unit = (it.original_price !== it.final_price ? '<s>' + money(it.original_price) + '</s> ' : '') + money(it.final_price) + ' / szt.';
      var disc = (it.line_level_discount_allocations || []).map(function(d){
        var t = d.discount_application && d.discount_application.title ? d.discount_application.title : 'Rabat';
        return '<div class="u save">' + esc(t) + ': −' + money(d.amount) + '</div>';
      }).join('');
      h += '<div class="vc-item">' +
        '<a href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(imgUrl(it.image, 160)) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div><a class="n" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
          '<div class="u">' + unit + '</div>' + disc +
          '<div class="vc-qty">' +
            '<button type="button" data-q="' + esc(it.key) + '" data-n="' + (it.quantity - 1) + '" aria-label="Mniej">−</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-q="' + esc(it.key) + '" data-n="' + (it.quantity + 1) + '" aria-label="Więcej">+</button>' +
            '<button type="button" class="vc-rm" data-q="' + esc(it.key) + '" data-n="0">Usuń</button>' +
          '</div></div>' +
        '<div class="vc-line">' + money(it.final_line_price) + '</div>' +
      '</div>';
    });
    var cartDisc = (cart.cart_level_discount_applications || []).map(function(d){
      return '<div class="save"><span>' + esc(d.title || 'Rabat') + '</span><span>−' + money(d.total_allocated_amount) + '</span></div>';
    }).join('');
    var lineDisc = original - cart.items_subtotal_price;
    h += '<div class="vc-sum">' +
      (lineDisc > 0 ? '<div><span>Wartość</span><span>' + money(original) + '</span></div><div class="save"><span>Zniżka za komplet</span><span>−' + money(lineDisc) + '</span></div>' : '') +
      cartDisc +
      '<div><span>Wysyłka</span><span>' + esc(V.shippingNote || 'w kasie') + '</span></div>' +
      '<div class="tot"><span>Razem</span><span>' + money(cart.total_price) + '</span></div>' +
    '</div>';
    var bags = cart.items.reduce(function(n, it){ return n + (/^box/i.test(it.product_type || '') ? 0 : it.quantity); }, 0);
    var hint = bags === 1 ? V.hint1 : (bags === 2 ? V.hint2 : '');
    if (hint) h += '<div class="vc-hint">' + esc(hint) + '</div>';
    if (V.footNote) h += '<div class="vc-note">' + esc(V.footNote) + '</div>';
    body.innerHTML = h;
    foot.innerHTML = '<a class="btn btn-gold" href="/checkout" data-checkout>Przejdź do kasy · ' + money(cart.total_price) + '</a>' +
      '<button type="button" class="vc-back" data-cart-close>Kupuję dalej</button>';
  }

  function refresh(){ return getCart().then(function(c){ render(c); return c; }); }

  function change(key, qty){
    body.classList.add('is-busy');
    return req(path(R.cart_change, '.js'), { id: key, quantity: qty })
      .then(render)
      .catch(function(e){ toast(e.message, true); return refresh(); })
      .then(function(){ body.classList.remove('is-busy'); });
  }

  /* stare notatki z wcześniejszej wersji koszyka (pole paczkomatu) nie powinny trafiać do zamówień */
  function clearOldNote(cart){
    if (noteCleared || !cart || !cart.note) return;
    noteCleared = true;
    req(path(R.cart_update, '.js'), { note: '' }).catch(function(){});
  }

  function add(id, qty, btn){
    if (!id) return Promise.resolve();
    var label = btn ? btn.innerHTML : '';
    if (btn){ btn.disabled = true; btn.textContent = 'Dodawanie…'; }
    return req(path(R.cart_add, '.js'), { items: [{ id: Number(id), quantity: qty || 1 }] })
      .then(function(){ return getCart(); })
      .then(function(cart){
        render(cart); setCount(cart.item_count, true);
        toast('Dodano do koszyka · ' + cart.item_count + ' szt.');
        openDrawer();
      })
      .catch(function(e){
        toast(e.status === 422 ? (e.message || 'Brak więcej sztuk tego modelu.') : e.message, true);
      })
      .then(function(){ if (btn){ btn.disabled = false; btn.innerHTML = label; } });
  }

  if (drawer){
    try {
      if (!sessionStorage.getItem('vNoteChk')){ sessionStorage.setItem('vNoteChk', '1'); getCart().then(clearOldNote).catch(function(){}); }
    } catch(err){}
    document.addEventListener('click', function(e){
      var t = e.target;
      var opener = t.closest('[data-cart-open]');
      if (opener){ e.preventDefault(); refresh(); openDrawer(); return; }
      if (t.closest('[data-cart-close]') || t === overlay){ closeDrawer(); return; }
      var q = t.closest('[data-q]');
      if (q && drawer.contains(q)){ change(q.getAttribute('data-q'), Math.max(0, parseInt(q.getAttribute('data-n'), 10) || 0)); return; }
      var co = t.closest('[data-checkout]');
      if (co){ co.textContent = 'Przechodzę do kasy…'; return; }
      var addBtn = t.closest('[data-add]');
      if (addBtn && addBtn.tagName === 'BUTTON'){ e.preventDefault(); e.stopPropagation(); add(addBtn.getAttribute('data-add'), 1, addBtn); }
    });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && isOpen()) closeDrawer(); });
    window.addEventListener('pageshow', function(e){ if (e.persisted) refresh(); });
  }

  /* ---------- karta produktu ---------- */
  var pp = $('[data-product]');
  if (pp){
    var form = $('#ppForm', pp) || $('.pp-form', pp);
    var idInput = form ? $('[data-variant-id]', form) : null;
    var addBtn = form ? $('[data-add-btn]', form) : null;
    var sel = $('[data-variant-select]', pp);
    var priceEl = $('[data-price]', pp), stockEl = $('[data-stock]', pp);
    var variants = [];
    try { variants = JSON.parse(($('[data-variants]', pp) || {}).textContent || '[]'); } catch(err){}

    if (sel){
      sel.addEventListener('change', function(){
        var v = variants.filter(function(x){ return String(x.id) === sel.value; })[0];
        if (!v) return;
        idInput.value = v.id;
        priceEl.innerHTML = money(v.price) + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '');
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? '+ Dodaj do koszyka' : 'Wyprzedane';
        if (stockEl) stockEl.classList.toggle('is-hidden', !v.available);
        if (window.history && history.replaceState){
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
        }
      });
    }
    if (form && drawer){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        add(idInput.value, 1, addBtn);
      });
    }

    /* galeria + powiększenie */
    var gallery = [];
    try { gallery = JSON.parse(($('[data-gallery]', pp) || {}).textContent || '[]'); } catch(err){}
    var mainWrap = $('[data-zoom-open]', pp);
    var mainImg = mainWrap ? $('img', mainWrap) : null;
    var thumbs = $$('[data-thumb]', pp);
    var zoom = $('[data-zoom]'), zImg = $('[data-zoom-img]'), zCount = $('[data-zoom-count]');
    var cur = 0;
    function show(i){
      if (!gallery.length || !mainImg) return;
      cur = (i + gallery.length) % gallery.length;
      var g = gallery[cur];
      mainImg.removeAttribute('srcset'); mainImg.removeAttribute('sizes');
      mainImg.classList.add('is-loading');
      mainImg.onload = function(){ mainImg.classList.remove('is-loading'); };
      mainImg.src = g.src;
      thumbs.forEach(function(b, k){ b.classList.toggle('active', k === cur); });
      if (zoom && zoom.classList.contains('show')) zoomView();
    }
    function zoomView(){
      if (!zoom) return;
      zImg.src = gallery[cur].big || gallery[cur].src;
      var multi = gallery.length > 1;
      $$('.zoom-nav', zoom).forEach(function(b){ b.style.display = multi ? 'flex' : 'none'; });
      zCount.style.display = multi ? 'block' : 'none';
      zCount.textContent = (cur + 1) + ' / ' + gallery.length;
    }
    function openZoom(){ if (!gallery.length || !zoom) return; zoomView(); zoom.classList.add('show'); document.body.style.overflow = 'hidden'; }
    function closeZoom(){ if (!zoom) return; zoom.classList.remove('show'); document.body.style.overflow = ''; }
    thumbs.forEach(function(b){ b.addEventListener('click', function(){ show(parseInt(b.getAttribute('data-thumb'), 10)); }); });
    if (mainWrap){
      mainWrap.addEventListener('click', openZoom);
      mainWrap.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); openZoom(); } });
      var sx = null;
      mainWrap.addEventListener('touchstart', function(e){ sx = e.changedTouches[0].clientX; }, { passive: true });
      mainWrap.addEventListener('touchend', function(e){
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) > 40){ e.preventDefault(); show(cur + (dx > 0 ? -1 : 1)); }
      });
    }
    if (zoom){
      zoom.addEventListener('click', function(e){ if (e.target === zoom || e.target === zImg) closeZoom(); });
      $('[data-zoom-close]', zoom).addEventListener('click', function(e){ e.stopPropagation(); closeZoom(); });
      $('[data-zoom-prev]', zoom).addEventListener('click', function(e){ e.stopPropagation(); show(cur - 1); });
      $('[data-zoom-next]', zoom).addEventListener('click', function(e){ e.stopPropagation(); show(cur + 1); });
      document.addEventListener('keydown', function(e){
        if (!zoom.classList.contains('show')) return;
        if (e.key === 'Escape') closeZoom();
        if (e.key === 'ArrowLeft') show(cur - 1);
        if (e.key === 'ArrowRight') show(cur + 1);
      });
      var zx = null;
      zoom.addEventListener('touchstart', function(e){ zx = e.changedTouches[0].clientX; }, { passive: true });
      zoom.addEventListener('touchend', function(e){
        if (zx === null) return;
        var dx = e.changedTouches[0].clientX - zx; zx = null;
        if (Math.abs(dx) > 40) show(cur + (dx > 0 ? -1 : 1));
      }, { passive: true });
    }
  }

  /* ---------- filtr Bestsellery ---------- */
  $$('.filterbar').forEach(function(bar){
    var section = bar.closest('section');
    bar.addEventListener('click', function(e){
      var chip = e.target.closest('.chip'); if (!chip) return;
      $$('.chip', bar).forEach(function(c){ c.classList.toggle('active', c === chip); });
      var f = chip.getAttribute('data-filter');
      $$('.card', section).forEach(function(card){
        var tags = card.getAttribute('data-tags') || '';
        card.classList.toggle('is-hidden-by-filter', f !== 'all' && tags.indexOf(',' + f + ',') === -1);
      });
    });
  });

  /* ---------- pojawianie przy przewijaniu ---------- */
  if ('IntersectionObserver' in window && !reduced){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting){ en.target.classList.add('in-view'); io.unobserve(en.target); } });
    }, { threshold: .12, rootMargin: '0px 0px -6% 0px' });
    $$('[data-reveal]').forEach(function(el){ io.observe(el); });
    setTimeout(function(){ $$('[data-reveal]').forEach(function(el){ el.classList.add('in-view'); }); }, 4000);
  } else {
    $$('[data-reveal]').forEach(function(el){ el.classList.add('in-view'); });
  }

  /* ---------- pasek postępu, górny pasek, baner ---------- */
  var prog = $('[data-progress]'), topbar = $('[data-topbar]');
  var heroEl = $('[data-hero]'), tiles = $('[data-hero-tiles]');
  var ticking = false;
  function onScroll(){
    var h = document.documentElement;
    var max = h.scrollHeight - h.clientHeight;
    var y = window.scrollY || h.scrollTop;
    if (prog) prog.style.width = (max > 0 ? (y / max) * 100 : 0) + '%';
    if (topbar) topbar.classList.toggle('scrolled', y > 40);
    if (tiles){
      var t = Math.min(1, y / ((window.innerHeight || 800) * .7));
      tiles.style.opacity = String(1 - t);
      tiles.style.transform = 'translateY(' + (t * 40) + 'px)';
    }
    ticking = false;
  }
  document.addEventListener('scroll', function(){ if (!ticking){ ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  onScroll();

  if (heroEl && tiles && !reduced && window.matchMedia('(hover:hover)').matches){
    var pw = $$('.pwrap', tiles), mx = 0, my = 0, raf = null;
    function par(){
      pw.forEach(function(p){
        var d = parseFloat(p.getAttribute('data-depth') || '0.05');
        p.style.transform = 'translate(' + (mx * d * 100) + 'px,' + (my * d * 100) + 'px)';
      });
      raf = null;
    }
    heroEl.addEventListener('mousemove', function(e){
      var r = heroEl.getBoundingClientRect();
      mx = (e.clientX - r.left) / r.width - .5; my = (e.clientY - r.top) / r.height - .5;
      if (!raf) raf = requestAnimationFrame(par);
    });
    heroEl.addEventListener('mouseleave', function(){ mx = 0; my = 0; if (!raf) raf = requestAnimationFrame(par); });
  }

  /* motyw w edytorze Shopify: sekcje dodane na żywo od razu widoczne */
  document.addEventListener('shopify:section:load', function(e){
    $$('[data-reveal]', e.target).forEach(function(el){ el.classList.add('in-view'); });
  });
})();

